import ParentTagSelector from "./ParentTagSelector"

export default  ParentTagSelector;
